/**
 * The canonical market list, as Orbit queries it.
 *
 * Markets are the Medplum `Location` resources carrying an explicit `market` type
 * coding — deliberately *not* everything typed `procedure-institution`. That
 * broader type also matches `National Number`, a phone-routing pseudo-location in
 * San Francisco which carries real coordinates, so keying on it would offer a rep
 * a market nobody can be booked at.
 *
 * Names here are the bare canonical ones (`Miami`, not `Greater Miami`). The
 * `Greater` spellings exist only at bariendo-be's patient-facing ZIP boundary,
 * because `Location.name` is denormalized into `Appointment.location.display` and
 * into analytics, so renaming the resources was not an option.
 */

import { Location } from '@medplum/fhirtypes';

export const MARKET_LOCATION_TYPE_SYSTEM = 'http://bariendo.com/fhir/CodeSystem/location-type';
export const MARKET_LOCATION_TYPE_CODE = 'market';

export const MARKET_SEARCH_PARAMS: Record<string, string> = {
  type: `${MARKET_LOCATION_TYPE_SYSTEM}|${MARKET_LOCATION_TYPE_CODE}`,
  status: 'active',
  _count: '100',
};

/**
 * Sorted and de-duplicated: the order is what a rep scans down, so it must not
 * depend on Medplum's result ordering, and two resources sharing a name must not
 * produce two identical options.
 */
export function marketNames(locations: Location[]): string[] {
  const names = new Set<string>();

  for (const location of locations) {
    if (location.name) names.add(location.name);
  }

  return [...names].sort((a, b) => a.localeCompare(b));
}
